<pg-home-section-4>
  <section id="home-section-4">
  <img src={ornament4} alt="" class="ornament-4">
    <header>
      <h2>Soluções</h2>
      <p>Soluções financeiras sofisticadas e personalizadas para cada cliente:</p>
    </header>

    <div class="container">
      <div class="content">
        <div class="card">
          <span>Investment<br>Banking</span>
        </div>
        <div class="card">
          <span>Soluções<br>de Crédito</span>
        </div>
        <div class="card">
          <span>Outros<br>Negócios</span>
        </div>
      </div>
      <a href="https://lp.vlgicorporate.com.br/fale-com-especialista" target="_blank" class="btn">
        Ver mais
      </a>
    </div>
  </section>

  <script>
    import './pg-home-section-4.scss'

    import ornament4 from '../../media/home-ornaments/home-4.svg'

  export default {
      ornament4,
    }
  </script>
</pg-home-section-4>
